// extracted by mini-css-extract-plugin
export default {"arc3-breadcrumb":"Y0JTAvB68wt5Rj+dJtK-Og==","--borderless":"Svfb0NjcJKm3luni+QYb9g=="};